import { Parser, ParseResult } from "../types";
import jsYaml from "js-yaml";

export const yamlParser: Parser = {
  name: "yaml",
  priority: 2,
  parse: (content: string): ParseResult<Record<string, unknown>> => {
    try {
      const documents = jsYaml.loadAll(content) as Record<string, unknown>[];
      const result: Record<string, unknown> = {};

      for (const doc of documents) {
        if (!doc || typeof doc !== "object") {
          continue;
        }

        // Check for stringData first (K8s Secret unencoded format)
        if ("stringData" in doc && typeof doc.stringData === "object" && doc.stringData !== null) {
          Object.assign(result, doc.stringData);
        }
        // Check for data property (K8s Secret or nested YAML format)
        else if ("data" in doc && typeof doc.data === "object" && doc.data !== null) {
          Object.assign(result, doc.data);
        }
        // Use entire document as key-value pairs
        else {
          Object.assign(result, doc);
        }
      }

      if (Object.keys(result).length === 0) {
        return { success: false, data: null, format: "yaml", error: "No valid entries found" };
      }

      return { success: true, data: result, format: "yaml" };
    } catch (e) {
      return { success: false, data: null, format: "yaml", error: e.message };
    }
  },
};
